/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Onboarding_Motivation_Example_3Inputs */

const en_us2_onboarding_motivation_example_3 = /** @type {(inputs: Onboarding_Motivation_Example_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`I have a wedding in six months.`)
};

const pt_br2_onboarding_motivation_example_3 = /** @type {(inputs: Onboarding_Motivation_Example_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vou casar daqui a seis meses.`)
};

const es_419_onboarding_motivation_example_3 = /** @type {(inputs: Onboarding_Motivation_Example_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Me caso en seis meses.`)
};

const pt_pt2_onboarding_motivation_example_3 = /** @type {(inputs: Onboarding_Motivation_Example_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vou casar daqui a seis meses.`)
};

const fr_fr2_onboarding_motivation_example_3 = /** @type {(inputs: Onboarding_Motivation_Example_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Je me marie dans six mois.`)
};

const de_de2_onboarding_motivation_example_3 = /** @type {(inputs: Onboarding_Motivation_Example_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`In sechs Monaten habe ich eine Hochzeit.`)
};

const it_it2_onboarding_motivation_example_3 = /** @type {(inputs: Onboarding_Motivation_Example_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tra sei mesi mi sposo.`)
};

/**
* | output |
* | --- |
* | "I have a wedding in six months." |
*
* @param {Onboarding_Motivation_Example_3Inputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const onboarding_motivation_example_3 = /** @type {((inputs?: Onboarding_Motivation_Example_3Inputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Onboarding_Motivation_Example_3Inputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_onboarding_motivation_example_3(inputs)
	if (locale === "es-419") return es_419_onboarding_motivation_example_3(inputs)
	if (locale === "pt-PT") return pt_pt2_onboarding_motivation_example_3(inputs)
	if (locale === "fr-FR") return fr_fr2_onboarding_motivation_example_3(inputs)
	if (locale === "de-DE") return de_de2_onboarding_motivation_example_3(inputs)
	if (locale === "it-IT") return it_it2_onboarding_motivation_example_3(inputs)
	return en_us2_onboarding_motivation_example_3(inputs)
});
export { onboarding_motivation_example_3 as "onboarding.motivation.example_3" }